import { render, staticRenderFns } from "./PDLCreate.vue?vue&type=template&id=a061808c&scoped=true&"
import script from "./PDLCreate.vue?vue&type=script&lang=js&"
export * from "./PDLCreate.vue?vue&type=script&lang=js&"
import style0 from "./PDLCreate.vue?vue&type=style&index=0&id=a061808c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a061808c",
  null
  
)

export default component.exports